// blog data

export const Blogs = [
    {
        id:1,
        name:"Why Layer2s are important for the development of etherium",
        tags:["eth, blockchain"],
        date:"7 Sept, 2023",
        imgSrc:"",
        link:""
    }
  
] 